import React, { FC } from "react"
import { ShortcodeLink } from "../../models"
import { useJCommonContext } from "../../../JCommonProvider"
import { JCMSCTA } from "../../../JCMSCTA"


interface JShortcodeLinkProps extends ShortcodeLink {}

export const JShortcodeLink: FC<JShortcodeLinkProps> = (props) => {
    const { navigate } = useJCommonContext()
    return (
        <JCMSCTA 
            {...props}
            color={props.color || 'primary'}
            type="WRAPLESS"
            action={() => props.scope && navigate(props.scope, props.scopeParameters)} 
        />
    )
}
